export const createShareListManager = (queryClient, shareCategoryOrParams) => {
  const getShareListKey = () => {
    return shareCategoryOrParams != null ? ['shares', shareCategoryOrParams] : ['shares'];
  };

  const removeShareFromList = async ({ id: shareId }) => {
    const shareListKey = getShareListKey();
    await queryClient.cancelQueries({ queryKey: shareListKey });
    const originalShareList = queryClient.getQueryData(shareListKey);
    if (originalShareList) {
      const shareListAfterRemoval = Array.isArray(originalShareList)
        ? originalShareList.filter((share) => {
            const currentShareId = share.id || share.sharedDocumentId || share.sharedDocument?.id;
            return currentShareId !== shareId;
          })
        : originalShareList?.data
        ? { ...originalShareList, data: originalShareList.data.filter((share) => {
            const currentShareId = share.id || share.sharedDocumentId || share.sharedDocument?.id;
            return currentShareId !== shareId;
          })}
        : originalShareList?.items
        ? { ...originalShareList, items: originalShareList.items.filter((share) => {
            const currentShareId = share.id || share.sharedDocumentId || share.sharedDocument?.id;
            return currentShareId !== shareId;
          })}
        : originalShareList;
      queryClient.setQueryData(shareListKey, shareListAfterRemoval);
    }
    return { originalShareList, shareListKey };
  };

  const restoreShareList = (error, actionData, savedState, errorMessage = 'Failed to process share') => {
    console.error(errorMessage, error);
    console.error('Error details:', error.response || error.message);
    if (savedState?.originalShareList && savedState?.shareListKey) {
      queryClient.setQueryData(savedState.shareListKey, savedState.originalShareList);
    }
    queryClient.refetchQueries({ queryKey: ['shares'] });
  };

  return { removeShareFromList, restoreShareList, getShareListKey };
};

